import React from 'react';
import { displayName, nameInitials } from '../../../services/displayName';
import { colors } from '../../../theme';
import { S } from '../dashboardStyles';
import EmptyState from '../EmptyState';
import { MessageSquare } from 'lucide-react';

export default function ChatListTab({ users, lastMessages, user, unreadCounts, openChat, fmtTime, utc, userStatuses = {} }) {
  return (
    <div>
      {lastMessages.length === 0 && users.length === 0 && <EmptyState icon={MessageSquare} text="Нет диалогов" sub="Начните чат из контактов" />}
      {/* Dialogs with last messages */}
      {lastMessages.map(msg => {
        const partnerId = msg.from_user_id === user.id ? msg.to_user_id : msg.from_user_id;
        const partnerUser = users.find(u => u.id === partnerId);
        const name = msg.partner_name || displayName(partnerUser) || '?';
        // Live status first, REST snapshot only as a fallback — the same rule as
        // the contacts list, which had the two disagreeing on screen.
        const rtStatus = userStatuses[partnerId];
        // 'asleep' means reachable by push, not present. Counting it as online
        // would put a green dot on a phone whose app has been closed for hours.
        const online = rtStatus
          ? (rtStatus !== 'offline' && rtStatus !== 'asleep')
          : (partnerUser?.online || false);
        const isMine = msg.from_user_id === user.id;
        const mType = msg.msgType || msg.type || 'text';
        const previewText = mType === 'voice' ? '🎤 Голосовое' : mType === 'image' ? '📷 Фото' : mType === 'file' ? '📎 ' + (msg.file_name || 'Файл') : (msg.content || '').slice(0, 50);
        const preview = (isMine ? 'Вы: ' : '') + previewText;
        const unread = unreadCounts[partnerId] || 0;
        return (
          <div key={partnerId} style={S.chatPreviewRow} onClick={() => openChat(partnerUser || { id: partnerId, username: name, sip_extension: msg.partner_extension, last_seen: msg.partner_last_seen })}>
            <div style={{ position: 'relative', flexShrink: 0 }}>
              <div style={S.compactAvatar}>{nameInitials(name)}</div>
              {online && <div style={S.onlineDot} />}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={S.compactName}>{name}</div>
                <div style={{ fontSize: 11, color: colors.gray400, flexShrink: 0 }}>{fmtTime(msg.created_at)}</div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 2 }}>
                <div style={{ fontSize: 13, color: colors.gray400, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>{preview}</div>
                {unread > 0 && <span style={S.badge}>{unread}</span>}
              </div>
            </div>
          </div>
        );
      })}
      {/* Users without messages yet */}
      {users.filter(u => !lastMessages.find(m => {
        const pid = m.from_user_id === user.id ? m.to_user_id : m.from_user_id;
        return pid === u.id;
      })).map(u => {
        const online = u.last_seen && (Date.now() - utc(u.last_seen).getTime()) < 5 * 60 * 1000;
        return (
          <div key={u.id} style={S.chatPreviewRow} onClick={() => openChat(u)}>
            <div style={{ position: 'relative', flexShrink: 0 }}>
              <div style={S.compactAvatar}>{nameInitials(u)}</div>
              {online && <div style={S.onlineDot} />}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={S.compactName}>{displayName(u)}</div>
              <div style={{ fontSize: 13, color: colors.gray300, marginTop: 2 }}>Нет сообщений</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
